<template>
  <div class="category-list">
    <el-row>
      <el-col :span="24">
        <el-alert
            title="温馨提示"
            type="success"
            close-text="知道了"
            show-icon>
          <p style="color: #ff0036">可以创建普通和免单专题</p>
          <p><a style="color: #ff0036" href="https://www.yuque.com/yifakeji/irpssl/hlh0km"
                target="_blank">点击查看专题教程</a>
          </p>
          <p><a href="https://www.yuque.com/yifakeji/irpssl/ue7wyt" target="_blank"
                style="color: #ff0036">点击查看用户免单教程</a></p>
        </el-alert>

      </el-col>
    </el-row>
    <el-row class="">
      <el-collapse accordion v-model="activeNames">
        <el-collapse-item name="1">
          <template slot="title">
            <div class="title">
              <div @click.stop class="opt-area">
                <el-button type="success" size="medium"
                           @click="showNewPanel">{{ activeNames.length > 0 ? '收起' : '新增专题' }}
                </el-button>
              </div>
            </div>
          </template>
          <el-form :label-position="labelPosition" ref="item-form" :model="item" :rules="rules"
                   label-width="150px">
            <el-form-item label="专题名称:" prop="name">
              <el-col :span="12">
                <el-input :span="6" placeholder="请输入专题名称"
                          v-model="item.name"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="专题图片:" prop="imgUrl">
              <el-col :span="12">
                <el-input :span="6" placeholder="请输入专题图片地址" type="textarea" autosize
                          v-model="item.imgUrl"></el-input>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">专题图片格式需要是 jpg 格式，其它格式不行</p>
                  <p class="alter-text"><a href="https://www.yuque.com/yifakeji/irpssl/mq33kr" target="_blank"
                                           style="color: #ff0036">点击查看获取图片地址教程</a></p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="展示模式:" prop="upcLayout">
              <el-col :span="12">
                <el-radio-group v-model="upcLayout">
                  <el-radio border :label="'smallPic'">小图</el-radio>
                  <el-radio border :label="'bigPic'">大图</el-radio>
                </el-radio-group>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">大图：商品图片采用轮播的形式</p>
                  <p class="alter-text">小图：商品图片采用小图，可以看到所有图片，然后点击查看大图</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="专题类型:" prop="upcType">
              <el-col :span="12">
                <el-radio-group v-model="upcType">
                  <el-radio border :label="'COMMON'">普通</el-radio>
                  <el-radio border :label="'FREE_ORDER'">免单</el-radio>
                </el-radio-group>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">免单类型，可以通过淘礼金创建免单</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="是否开启用户免单" prop="openFreeOrder" v-if="upcType=='FREE_ORDER'">
              <el-col :span="12">
                <el-switch v-model="openFreeOrder"></el-switch>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">勾选后，小程序首页才会展示免单</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="是否仅新用户可见" prop="onlyNewUser" v-if="upcType=='FREE_ORDER'">
              <el-col :span="12">
                <el-switch v-model="onlyNewUser"></el-switch>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">勾选后，只有未下过单的用户才可以看到</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="是否仅限定群购买:" prop="onlyTheseGroup">
              <el-col :span="12">
                <el-switch v-model="onlyTheseGroup"></el-switch>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">勾选后，只有限定的群成员才可以购买</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="限定群:" v-if="onlyTheseGroup">
              <el-col :span="24" class="rules"
                      v-for="(group,index) in choseGroups">
                <el-col :span="12">
                  <el-input
                      type="input"
                      disabled
                      v-model="group.groupName">
                  </el-input>
                </el-col>
              </el-col>
              <el-col :span="12">
                <el-button type="primary" size="medium" @click="toChooseGroups">选择群</el-button>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">勾选后，只有限定的群成员才可以购买</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="群或者微信二维码:" prop="groupInfoQrcodeUrl" v-if="onlyTheseGroup">
              <el-col :span="12">
                <el-input :span="6" placeholder="请输入群或者客服二维码图片地址" type="textarea" autosize
                          v-model="groupInfoQrcodeUrl"></el-input>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">输入群或者客服二维码，会提示用户加群或者加好友</p>
                </el-alert>
              </el-col>
            </el-form-item>

            <el-form-item label="用户提示:" prop="groupInfoTip" v-if="onlyTheseGroup">
              <el-col :span="12">
                <el-input :span="6" placeholder="请输入用户提示：比如长按识别上面二维码添加好友" type="textarea" autosize
                          v-model="groupInfoTip"></el-input>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">当用户不是从指定群进入的时候，会提示添加群或者好友，此处可以自定义提示内容</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="是否需要邀请好友:" prop="needInvite">
              <el-col :span="12">
                <el-switch v-model="needInvite"></el-switch>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">勾选后，需要邀请好友数满足条件才能继续</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="邀请好友数:" prop="groupInfoTip" v-if="needInvite">
              <el-col :span="12">
                <el-input :span="6" placeholder="需要邀请多少个直属下级才可以购买" type="input"
                          v-model="needInviteCount"></el-input>
              </el-col>
              <el-col :span="24">
                <el-alert
                    close-text="知道了"
                    type="success">
                  <p class="alter-text">购买需要满足邀请的直属下级人数</p>
                </el-alert>
              </el-col>
            </el-form-item>
            <el-form-item label="免单banner地址:" prop="freeOrderBanner" v-if="upcType=='FREE_ORDER'">
              <el-col :span="12">
                <el-input :span="6" placeholder="请输入免单banner图片地址" type="textarea" autosize
                          v-model="item.freeOrderBanner"></el-input>
              </el-col>
            </el-form-item>
            <el-form-item label="专题描述:" prop="introduce">
              <el-col :span="12">
                <el-input :span="6" placeholder="请输入专题描述" type="textarea" autosize
                          v-model="item.introduce"></el-input>
              </el-col>
            </el-form-item>

            <el-form-item>
              <el-button type="primary" size="medium" @click="onSubmit">保存</el-button>
            </el-form-item>
          </el-form>

        </el-collapse-item>
      </el-collapse>
    </el-row>
    <el-dialog title="选择群" :visible.sync="newDialogShow">
      <el-row v-if="false">
        <el-col :span="12">
          <el-form :inline="true" class="search-area">
            <el-form-item>
              <el-input v-model="keyword" placeholder="请输入群名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="loadGroups(true)">查询</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
      <el-checkbox-group
          v-model="checkedGroups">
        <el-table
            :data="groups"
            ref="newUserLevelsTable"
            highlight-current-row
            v-if="groups.length >0"
            border>
          <el-table-column
              label="选择">
            <template slot-scope="scope">
              <el-checkbox :label="scope.row.id+'yftaoke'+scope.row.openGroupId+'yftaoke'+scope.row.groupName"
                           :key="scope.row.id">{{ scope.row.groupName }}
              </el-checkbox>
            </template>
          </el-table-column>
        </el-table>
      </el-checkbox-group>
      <div class="pagination">
        <el-pagination
            background
            @current-change="loadGroups(false)"
            :current-page.sync="groupPage"
            :page-size="groupPageSize"
            layout="total,prev, pager, next"
            :total="groupTotal">
        </el-pagination>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="newDialogShow = false">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </div>
    </el-dialog>

    <el-row>
      <el-col :span="24">
        <el-table
            :data="items"
            border>
          <el-table-column
              label="名称"
              width="200"
              prop="name">
          </el-table-column>
          <el-table-column
              label="专题图片"
              width="250">
            <template slot-scope="scope">
              <div class="cell-item-img">
                <el-popover
                    placement="right"
                    trigger="hover"
                    width="300"
                    :title="scope.row.name"
                    :ref="'popover-' + scope.row.id">
                  <img :src="scope.row.imgUrl" v-show="scope.row.imgUrl">
                  <img slot="reference" :src="scope.row.imgUrl"
                       v-show="scope.row.imgUrl"
                       class="media-image"/>
                </el-popover>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              label="展示模式"
              prop="upcLayout">
            <template slot-scope="scope">
              {{ scope.row.upcLayout == 'bigPic' ? '大图' : '小图' }}
            </template>
          </el-table-column>
          <el-table-column
              label="专题类型"
              prop="upcType">
            <template slot-scope="scope">
              {{ scope.row.upcType == 'COMMON' ? '普通' : '免单' }}
            </template>
          </el-table-column>
          <el-table-column
              label="是否开启用户免单"
              prop="openFreeOrder"
              width="150">
            <template slot-scope="scope">
              {{ scope.row.openFreeOrder ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column
              label="是否仅新用户可见"
              prop="onlyNewUser"
              width="150">
            <template slot-scope="scope">
              {{ scope.row.onlyNewUser ? '是' : '否' }}
            </template>
          </el-table-column>
          <el-table-column
              label="描述"
              prop="introduce"
              width="200"
          >
          </el-table-column>
          <el-table-column
              label="创建时间"
              prop="createTime"
              width="150">
          </el-table-column>
          <el-table-column
              label="操作"
              fixed="right"
              width="230">
            <template slot-scope="scope">
              <div class="opt-item">
                <el-button @click="editRow(scope.row)" size="mini" class="" type="success">编辑
                </el-button>
                <el-button @click="delRow(scope.row,scope.$index)" size="mini"
                           type="danger">删除
                </el-button>
              </div>
              <div class="opt-item">
                <el-button @click="shareImg(scope.row)" size="mini" class="" type="success">生成海报
                </el-button>
                <el-button @click="copyPagePath(scope.row)"
                           v-clipboard:copy="'/pages/user-products/user-products?themeId='+scope.row.id+'&themeType=upc'"
                           v-clipboard:success="onCopy"
                           v-clipboard:error="onError"
                           size="mini"
                           type="success">复制页面路径
                </el-button>
              </div>

            </template>
          </el-table-column>
        </el-table>
        <div class="pagination">
          <el-pagination
              background
              @current-change="handleCurrentChange"
              :current-page.sync="page"
              :page-size="pageSize"
              layout="total,prev, pager, next"
              :total="totalCount">
          </el-pagination>
        </div>
      </el-col>
    </el-row>
    <el-dialog
        title="海报生成成功"
        :visible.sync="dialogVisible"
        width="30%">
      <el-alert
          title="温馨提示"
          type="success"
          close-text="知道了"
          show-icon>
        <p>鼠标右键点击，保存图片</p>
        <p>微信扫码打开专题，转发好友</p>
      </el-alert>
      <img :src="shareImgUrl" class="shareimg" v-if="shareImgUrl">
      <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
             </span>
    </el-dialog>
  </div>
</template>
<script>
import {userProductCategoryApi} from "../../common/userProductCategoryApi";
import {wechatGroupsApi} from "@/common/wechatGroupApi";

export default {
  data() {
    return {
      activeNames: [],
      item: {},
      upcLayout: 'smallPic',
      upcType: 'COMMON',
      openFreeOrder: false,
      onlyNewUser: false,
      onlyTheseGroup: false,
      needInvite: false,
      needInviteCount: 0,
      groupInfoQrcodeUrl: '',
      groupInfoTip: '',
      choseGroups: [],
      checkedGroups: [],
      groups: [],
      newDialogShow: false,
      page: 1,
      pageSize: 10,
      totalCount: 0,
      groupPage: 1,
      groupPageSize: 10,
      groupTotal: 0,
      keyword: '',
      items: [],
      labelPosition: 'left',
      dialogVisible: false,
      shareImgUrl: null,
      rules: {
        introduce: [
          {required: false, message: '请输入专题简介', trigger: 'blur'},
          {min: 3, max: 100, message: '长度在 3 到 100 个字符', trigger: 'blur'}
        ],
      },
      newFormModel: {},
      config: {}
    }

  },
  created() {
    this.loadUserProductCategories()
  },
  methods: {
    loadUserProductCategories() {
      var that = this
      userProductCategoryApi.getUserProductCategories.call(that, {
        page: that.page,
        pageSize: that.pageSize
      }, function (res) {
        if (res.result.items) {
          var items = []
          for (let i = 0; i < res.result.items.length; i++) {
            let item = res.result.items[i];
            if (item.upcType != 'INVITE') {
              items.push(item)
            }
          }
          that.items = items;
        }

        if (res.result.totalCount) {
          that.totalCount = res.result.totalCount
        }

      })
    },
    showNewPanel() {
      this.item = {upcType: 'COMMON', upcLayout: 'smallPic'}
      if (this.activeNames.length > 0) {
        this.activeNames = []
      } else {
        this.activeNames = ["1"]
      }
    },
    onCopy() {
      this.successMsg("复制成功");
    },
    onError() {
      this.failMsg("复制失败")
    },

    editRow(item) {
      if (typeof (item.upcType) == "undefined") {
        this.upcType = 'COMMON'
      } else {
        this.upcType = item.upcType
      }
      if (typeof (item.upcLayout) == "undefined") {
        this.upcLayout = 'smallPic'
      } else {
        this.upcLayout = item.upcLayout
      }
      if (!item.onlyNewUser) {
        this.onlyNewUser = false
      } else {
        this.onlyNewUser = true
      }
      if (!item.openFreeOrder) {
        this.openFreeOrder = false
      } else {
        this.openFreeOrder = true
      }
      if (!item.onlyTheseGroup) {
        this.onlyTheseGroup = false
      } else {
        this.onlyTheseGroup = true
      }
      if (!item.needInvite) {
        this.needInvite = false
      } else {
        this.needInvite = true
      }
      if (item.config) {
        this.config = eval('(' + item.config + ')');
        this.groupInfoQrcodeUrl = this.config.groupInfoQrcodeUrl;
        this.groupInfoTip = this.config.groupInfoTip;
        this.choseGroups = this.config.choseGroups
        this.needInviteCount = this.config.needInviteCount
        this.checkedGroups = []
        if (this.choseGroups && this.choseGroups.length > 0) {
          for (let i = 0; i < this.choseGroups.length; i++) {
            let choseGroup = this.choseGroups[i];
            this.checkedGroups[i] = choseGroup.id + "yftaoke" + choseGroup.openGroupId + "yftaoke" + choseGroup.groupName
          }
        }

      }
      this.item = item;
      this.activeNames = ["1"]
      this.$forceUpdate()
    },
    delRow(item, index) {
      var that = this
      this.$confirm('如果专题里面包含淘礼金，删除后原来淘礼金不可用，需要重新创建淘礼金', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        userProductCategoryApi.deleteCategory.call(that, {id: item.id}, function (res) {
          that.$message({
            type: 'success',
            message: '删除成功!'
          });
          that.items.splice(index, 1)
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    shareImg(item) {
      var that = this
      userProductCategoryApi.getUserProductCategoryShareImg.call(that, {id: item.id}, function (res) {
        if (res.result.shareImg) {
          that.dialogVisible = true;
          that.shareImgUrl = res.result.shareImg
        }
      })
    },
    handleCurrentChange() {
      this.loadUserProductCategories()
    },
    onSubmit() {
      var that = this;
      this.$refs['item-form'].validate((valid) => {
        if (valid) {
          that.item.upcLayout = that.upcLayout
          that.item.upcType = that.upcType
          that.item.onlyNewUser = that.onlyNewUser
          that.item.openFreeOrder = that.openFreeOrder
          that.item.openFreeOrder = that.openFreeOrder
          that.item.onlyTheseGroup = that.onlyTheseGroup
          that.item.needInvite = that.needInvite
          that.config = {
            groupInfoTip: that.groupInfoTip,
            groupInfoQrcodeUrl: that.groupInfoQrcodeUrl,
            choseGroups: that.choseGroups,
            needInviteCount: that.needInviteCount
          }
          that.item.config = JSON.stringify(that.config)
          userProductCategoryApi.createOrUpdateCategory.call(that, that.item, function (res) {
            if (res.result.item && !that.item.id) {
              that.items.push(res.result.item)
            }
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

    },
    deleteGroup(index) {
      this.choseGroups.splice(index, 1)
    },
    toChooseGroups() {
      this.newDialogShow = true;
      this.loadGroups(true)
    },
    loadGroups(first) {
      if (first) {
        this.groups = []
        this.groupPage = 1
      }
      var data = {
        page: this.groupPage,
        pageSize: this.groupPageSize,
        keyword: this.keyword
      }
      wechatGroupsApi.getItems.call(this, data)

    },
    confirm() {
      console.log(this.checkedGroups)
      this.newDialogShow = false;
      var choseGroups = []
      for (var i = 0; i < this.checkedGroups.length; i++) {
        var group = this.checkedGroups[i]
        let items = group.split('yftaoke');
        choseGroups[i] = {
          id: items[0],
          openGroupId: items[1],
          groupName: items[2]
        }
      }
      this.choseGroups = choseGroups
    }
  }

}


</script>
<style lang="scss">

.media-image {
  width: 80px;
  vertical-align: middle;
}

.shareimg {
  width: 100%;
}

.opt-item {
  margin-bottom: 10px;
}

</style>